import { Button, Radio, RadioGroup, Stack } from '@chakra-ui/react';
import { COMMON_WEIGHT_BREAKS } from '@pelicargo/utils';
import { HiChevronLeft } from 'react-icons/hi';

import { RequestFilters } from '../../hooks/useRequestFilters';

type Props = {
  filters: RequestFilters;
  handleRadioFilterChange: (key: string) => (nextValue: string) => void;
  resetView: () => void;
};

export const WeightBreakFilter = ({ filters, handleRadioFilterChange, resetView }: Props) => {
  return (
    <Stack spacing="2" pt="2">
      <Stack direction="row" align="center" spacing="2">
        <Button variant="ghost" textStyle="label" size="xs" leftIcon={<HiChevronLeft />} onClick={resetView}>
          Weight Break
        </Button>
      </Stack>

      <Stack>
        <RadioGroup value={`${filters.weight_break}`} onChange={handleRadioFilterChange('weight_break')}>
          <Stack py="2">
            <Radio value="0">0 - 45</Radio>
          </Stack>
          {COMMON_WEIGHT_BREAKS?.map((node, i) => (
            <Stack key={node} py="2">
              <Radio value={`${node}`}>
                {node}
                {COMMON_WEIGHT_BREAKS?.[i + 1] ? ` - ${COMMON_WEIGHT_BREAKS?.[i + 1]}` : '+'}
              </Radio>
            </Stack>
          ))}
        </RadioGroup>
      </Stack>
    </Stack>
  );
};
